import { gql } from "@apollo/client";

export const FETCH_DOCUMENT_BY_REFERENCE = gql`
    query FetchDocumentByReference($reference: String!) {
        officialDocumentByReference(reference: $reference) {
            id
            name
            reference
            pdfUrl
            pdfFileUrl
            rootContentNode {
                id 
                type
                text
                sizeInTokens
                isPromptable
                isViewable
                metadata
                childNodes {
                    id
                    type
                    text
                    sizeInTokens 
                    isPromptable
                    isViewable
                    metadata
                }
            }
        }
    }
`;